export default ({ t, accountScopedRoute, isAdmin }) => ({
  name: 'Travel',
  label: t('SIDEBAR.TRAVEL'),
  icon: 'i-ph-airplane-tilt',
  children: [
    {
      name: 'Travel Flights',
      label: t('SIDEBAR.TRAVEL_FLIGHTS'),
      icon: 'i-ph-magnifying-glass',
      to: accountScopedRoute('travel_flight_search'),
    },
    {
      name: 'Travel Bookings',
      label: t('SIDEBAR.TRAVEL_BOOKINGS'),
      icon: 'i-ph-ticket',
      to: accountScopedRoute('travel_booking_lookup'),
    },
    {
      name: 'Travel History',
      label: t('SIDEBAR.TRAVEL_HISTORY'),
      icon: 'i-ph-clock-counter-clockwise',
      to: accountScopedRoute('travel_request_history'),
    },
    // Preferences change account-wide search behaviour, so the leaf is hidden from
    // agents. The route carries the same administrator gate, so this is presentation
    // rather than the control.
    ...(isAdmin
      ? [
          {
            name: 'Travel Preferences',
            label: t('SIDEBAR.TRAVEL_PREFERENCES'),
            icon: 'i-ph-sliders',
            to: accountScopedRoute('travel_preferences'),
          },
        ]
      : []),
  ],
});
